import { render, staticRenderFns } from "./LegalAssistanceFaqDropdown.vue?vue&type=template&id=1e9b03c2"
import script from "./LegalAssistanceFaqDropdown.vue?vue&type=script&lang=ts"
export * from "./LegalAssistanceFaqDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports